<template>
  <div class="verval">
    <v-card flat>
      <v-card-text>
        <h4 class="black--text">Daftar Kelompok Pendampingan KP</h4>
        <v-divider class="my-2" />
        <base-table-header
          :btnAdd="$allow('psp-peserta-kp.create')"
          :btnDownload="allowDownload"
          @add="onAdd"
          @reload="onReload"
          @search="onSearch"
          @download="onDownloadList"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              Jumlah Data <span class="blue--text font-weight-medium">{{ total }}</span>
            </div>
          </template>
        </base-table-header>
        <v-divider />
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row no-gutters>
                    <v-col cols="12" md="4">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="blue">
                          <v-icon dark>mdi-hospital-building</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 px-1">
                          <p class="caption grey--text">
                            Nama Kelompok KP
                          </p>
                          <span class="body-1">
                            <strong> {{ $getDeepObj(item, 'nama') || '-' }} </strong>
                          </span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Jumlah Anggota </small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <span class="blue--text"> {{ item.psp_kp_sekolahs.data.length || 0 }} </span> Sekolah
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col v-if="api === 'kp'" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Nama Instruktur</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <template v-if="getLastPendampingan(item)">
                              {{
                                (getLastPendampingan(item) &&
                                  getLastPendampingan(item)['akun_instruktur']['data'] &&
                                  getLastPendampingan(item)['akun_instruktur']['data']['nama']) ||
                                  '-'
                              }}
                            </template>
                            <template v-else>-</template>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" :md="api === 'kp' ? 2 : 4">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Jadwal yang ditugaskan</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <div v-if="api === 'kp'">
                              <template v-if="getLastPendampingan(item)">
                                <v-chip small color="success">
                                  Pertemuan
                                  {{
                                    (getLastPendampingan(item) && getLastPendampingan(item)['pendampingan_ke']) || '-'
                                  }}
                                </v-chip>
                              </template>
                              <template v-else>-</template>
                            </div>
                            <div v-else>
                              <v-chip v-if="getLastPendampingan(item).length === 4" small color="success">
                                Semua Jadwal
                              </v-chip>
                              <v-chip
                                v-else
                                v-for="(diklat, d) in getLastPendampingan(item)"
                                :key="d"
                                class="mr-1"
                                small
                                color="success"
                              >
                                Jadwal
                                {{ $getDeepObj(diklat, 'pendampingan_ke') || '-' }}
                              </v-chip>
                            </div>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Aksi</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-btn depressed small dark color="blue" @click="onDetail(item)">Lihat Detail</v-btn>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text>
                  <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full ref="modal" :title="formulir.title" @save="onSave">
      <component ref="formulir" :is="formulir.form" :initValue="formulir.init" />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import list from '@mixins/list';
import mixin from './mixin';
import actions from './action';
import FormKelompok from '../formulir/Kelompok';
export default {
  components: { FormKelompok },
  mixins: [list, mixin],
  data() {
    return {
      actions: actions,
      formulir: {},
    };
  },
  created() {
    Object.assign(this.attr, { api: this.api });
  },
  methods: {
    ...mapActions('diklatDkp', {
      fetch: 'fetch',
      create: 'create',
      update: 'update',
      delete: 'delete',
      getDetail: 'getDetail',
      downloadList: 'downloadList',
    }),
  },
};
</script>
